<div>
  <button mat-button (click)="clearAll()">Clear all</button>
</div>
<ng-container *ngFor="let notification of notificationList">
  <cars-notification [notification]="notification"></cars-notification>
</ng-container>
